import Splash from "../components/Splash";
import Login from "../components/Login/Login";
import Verify from "../components/Login/Verify";
import Home from "../components/Home/Home";
import Requests from "../components/Requests/Requests";
import Profile from "../components/Profile/Profile";
import WorkShifts from "../components/Profile/WorkShifts";
import Request from "../components/Requests/Request";
import EditProfile from "../components/Profile/EditProfile";
import Contents from "../components/Home/Contents";
import RequestsSmallCargo from "../components/Requests/RequestsSmallCargo";
import Finance from "../components/Profile/Finance";
import Wallet from "../components/Profile/Wallet";
import LocationPicker from "../components/Requests/LocationPicker";
import BlackListHistoryPage from "../components/Profile/BlackListHistoryPage";

const appRoutes = [
    {
        id : '0',
        path : '/',
        component : Splash
    },
    {
        id : '1',
        path : '/login',
        component : Login
    },
    {
        id : '2',
        path : '/verify',
        component : Verify
    },
    {
        id : '3',
        path : '/home',
        component : Home
    },
    {
        id : '4',
        path : '/requests',
        component : Requests
    },
    {
        id : '5',
        path : '/profile',
        component : Profile
    },
    {
        id : '6',
        path : '/work-shifts',
        component : WorkShifts
    },

    {
        id : '7',
        path : '/request/:id',
        component : Request
    },
    {
        id : '8',
        path : '/edit-profile',
        component : EditProfile
    },
    {
        id : '9',
        path : '/contents/:content',
        component : Contents
    },
    {
        id : '10',
        path : '/requests-sc',
        component : RequestsSmallCargo
    },
    {
        id : '11',
        path : '/requests/:page',
        component : Requests
    },
    {
        id : '12',
        path : '/finance',
        component : Finance
    },
    {
        id : '13',
        path : '/wallet',
        component : Wallet
    },
    {
        id : '14',
        path : '/location/:id',
        component : LocationPicker
    },
    {
        id : '15',
        path : '/history',
        component : BlackListHistoryPage
    },

];
export default appRoutes;